import React, { useEffect, useState, useCallback } from 'react';
import envConstants from "../Constants";
import axios from "../Axiosapi";
import { useParams } from 'react-router-dom';
import { Helmet } from "react-helmet-async";
import { Link } from 'react-router-dom';

const SingleBlog = () => {
    const [loading, setLoading] = useState(true);
    const [blogs, setBlogs] = useState([]);
    const [singleblog, setsingleBlog] = useState(null);
    const [error, setError] = useState(null);
    const { permalink } = useParams();
    const Datanotfound = '/assets/images/home-404.webp';

    useEffect(() => {
        const fetchBlog = async () => {
            setLoading(true);
            try {
                let url = `${envConstants.API_BASE_URL}/${permalink}/blog`;
                const response = await axios.get(url, { responseType: 'json' });
                setsingleBlog(response.data.data.blog);
                const activeBlogs = response.data.data.related_blogs.filter(blog => blog.active === 1);
                setBlogs(activeBlogs);
                setError(null);
            } catch (error) {
                if (error.response && error.response.status === 404) {
                    setError('Blog not found');
                } else {
                    setError('An error occurred while fetching the blog');
                }
            } finally {
                setLoading(false);
            }
        };

        fetchBlog();
    }, [permalink]);

    if (loading) return <div className="d-flex justify-content-center align-items-center p-5">
        <div className="spinner-border spinner-border-sm" role="status">
            <span className="visually-hidden">Loading...</span>
        </div>
    </div>;

    if (error) {
        return (
            <div className="text-center">
                <img src={Datanotfound} alt="Data Not Found" style={{ width: "40%", margin: "20px 0px" }} />
            </div>
        );
    }

    const canonicalUrl = singleblog._canonical_url ? singleblog._canonical_url || 'https://autopartstation.com.au/' : 'https://autopartstation.com.au/';
    const seotitle = singleblog._seo_title ? singleblog._seo_title || '' : '';
    const seodescription = singleblog._seo_description ? singleblog._seo_description || '' : '';
    const seotags = singleblog._seo_tags ? singleblog._seo_tags || '' : '';
    let schemaMarkup;
    if (singleblog && singleblog._schema_markup) {
        try {
            schemaMarkup = JSON.parse(singleblog._schema_markup);
        } catch (e) {
            schemaMarkup = null;
        }
    }
    if (!schemaMarkup) {
        const headline = singleblog?.title || '';
        const imageUrl = singleblog?.cover_image ? `${envConstants.API_BASE_PUBLIC_URL}${singleblog.cover_image}` : '';
        const publisherName = envConstants.STORE_NAME || 'Auto Part Station';
        const publisherLogo = 'https://autopartstation.com.au/auto-part.png';
        const datePublished = singleblog?.created_at || '';

        schemaMarkup = {
            "@context": "https://schema.org",
            "@type": "BlogPosting",
            "headline": headline,
            "image": imageUrl,
            "author": {
                "@type": "Organization",
                "name": publisherName
            },
            "publisher": {
                "@type": "Organization",
                "name": publisherName,
                "logo": {
                    "@type": "ImageObject",
                    "url": publisherLogo
                }
            },
            "datePublished": datePublished
        };
    }
    const index = singleblog._page_index !== undefined ? singleblog._page_index : '1';
    return (
        <>
            <Helmet>
                <title>{seotitle}</title>
                <meta name="description" content={seodescription} />
                <meta name="author" content={envConstants.STORE_META_AUTHOR ? envConstants.STORE_META_AUTHOR : 'Auto Part Station Store'} />
                <meta name="keywords" content={seotags} />
                <meta name="robots" content={index == 0 || index == '0' ? 'noindex, nofollow' : 'index, follow'} />
                <link rel="canonical" href={canonicalUrl} />
                <script type="application/ld+json">{JSON.stringify(schemaMarkup)}</script>
            </Helmet>

            <section className="article-hero" style={{ backgroundImage: `url(${envConstants.API_BASE_PUBLIC_URL}${singleblog.cover_image})` }}>
                <div className="floating-element"></div>
                <div className="floating-element"></div>

                <div className="container">
                    <div className="hero-content">
                        <span className="article-category">
                            <i className="fas fa-code"></i>
                            {new Date(singleblog.created_at).toLocaleDateString('en-US', {
                                year: 'numeric',
                                month: 'long',
                                day: 'numeric',
                            })}
                        </span>
                        <h1 className="article-title">{singleblog.title}</h1>
                    </div>
                </div>
            </section>

            <section className="article-content">
                <div className="container">
                    <div>
                        <div className="article-text" dangerouslySetInnerHTML={{ __html: singleblog.content }}></div>
                    </div>
                </div>
            </section>
            {blogs.length > 0 && (
                <section className="related-articles">
                    <div className="container">
                        <h2 className="related-title">Related Blogs</h2>
                        <div className="row">
                            {blogs.map((blog) => (
                                <div key={blog.id || blog.permalink} className="col-lg-4 col-md-6 mb-4">
                                    <div className="related-card">
                                        <div className="related-card-image" style={{ backgroundImage: `url(${envConstants.API_BASE_PUBLIC_URL}${blog.featured_images})` }} aria-label={blog.fimage_alt_text}>
                                            <i className="fas fa-palette"></i>
                                        </div>
                                        <div className="related-card-content">
                                            <div className="blog-meta">
                                                <span className="badge">

                                                </span>
                                            </div>
                                            <Link to={`/blog/${blog.permalink}`} className='text-decoration-none'><h3 className="related-card-title">{blog.title}</h3></Link>
                                            <p className="related-card-excerpt">{blog.description}</p>
                                            <div className="blog-footer">
                                                <Link to={`/blog/${blog.permalink}`} className="read-more">
                                                    Read More <i className="fas fa-arrow-right"></i>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            )}

        </>
    )
}

export default SingleBlog